import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../ToolTipIcon/ToolTipIcon';
import ToolTip from '../ToolTipIcon/ToolTip';
import SSTable from '../SSTable/SSTable';
import SSColumn from '../SSTable/SSColumn';
import AssetImage from '../Assets/AssetImage';
import { getPermissions } from '../../utils/getPermissions';
import { launchCreator } from '../../utils/launchCreator';
import { getParent } from '../../utils/parent';

export default class SequenceEntriesTable extends Component {
  getPosition = (item, index) => <span className="circle circle-md">{index + 1}</span>;

  getPreview = item => {
    return <AssetImage type="sign" item={item.sign} />;
  };

  getName = item => {
    const { auth } = this.props;
    const p = getPermissions(auth);
    let { tags = [] } = item.sign || {};

    if (!tags || !Array.isArray(tags)) {
      tags = [];
    }

    tags = tags.filter(Boolean);

    return (
      <div
        data-test="sequence-entry-name"
        className="max-w-[200px] overflow-hidden w-full justify-start flex flex-col items-start box-border"
      >
        <ToolTip toolText={item.sign.parent}>
          {!p.atLeastTierPro ? (
            item.sign.name
          ) : (
            <Link
              className="truncate w-full max-w-[200px]  inline-block "
              to={`/signs/${item.sign.id}`}
            >
              {item.sign.name}
            </Link>
          )}
        </ToolTip>
        {tags.length > 0 && (
          <div data-test="sequence-entry-tags" className="flex flex-wrap gap-1 mt-1">
            {tags.map(tag => (
              <span
                key={tag}
                className="inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-sunrise inset-ring inset-ring-orange-600/20"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  };

  getDimensions = item => item.sign.dimension;

  getRepeat = (item, index) => {
    const { auth, onChangeRepeat } = this.props;
    const p = getPermissions(auth);

    if (!p.atLeastTierPro) {
      return (
        <select value={-2} disabled className="w-[80px] 2xl:w-[120px]">
          <option value={-2}>Indefinitely</option>
        </select>
      );
    }

    return (
      <select
        className="w-[80px] 2xl:w-[120px] truncate"
        data-test="select-repeat"
        value={item.repeat}
        onChange={event => onChangeRepeat(event, index)}
        disabled={!p.writer}
      >
        <option value={1}>Don&apos;t loop</option>
        <option value={2}>2x</option>
        <option value={3}>3x</option>
        <option value={4}>4x</option>
        <option value={5}>5x</option>
        <option value={6}>6x</option>
        <option value={7}>7x</option>
        <option value={8}>8x</option>
        <option value={9}>9x</option>
        <option value={10}>10x</option>
        <option value={15}>15x</option>
        <option value={25}>25x</option>
        <option value={50}>50x</option>
        <option value={-2}>Indefinitely</option>
        <option value={-1}>Wait for Video</option>
        <option value={-3}>Loop until Touched</option>
      </select>
    );
  };

  getPlaylist = (item, index) => {
    const { auth, onClickPlaylist, onRemovePlaylist } = this.props;
    const {
      playlist: { id, name },
      sign: { hasVideo },
    } = item;
    const p = getPermissions(auth);

    if (!hasVideo) {
      return null;
    }

    return (
      <div className=" w-full h-[69px] flex items-center justify-center">
        <div className="playlist-actions  ">
          <select
            className="w-[120px] 2xl:w-[150px] truncate"
            data-test="select-playlist"
            value={name}
            disabled={!p.writer}
            onChange={event => {
              const val = +event.target.value;

              if (val === 1) {
                onClickPlaylist(index);
              }

              if (val === 2) {
                onRemovePlaylist(index);
              }
            }}
          >
            <option>{name}</option>
            <option value="1">{name ? 'Change' : 'Add'} Playlist</option>
            {name && <option value="2">Remove Playlist</option>}
          </select>
        </div>
        {id > -1 && (
          <ToolTipIcon toolText="Playlist Overview" href={`/playlists/${id}`} target="_blank">
            <img
              className="w-[30px] h-[30px] flex-shrink-0 max-w-none"
              alt="preview"
              src="/assets/images/icons/eye_device.svg"
            />
          </ToolTipIcon>
        )}
      </div>
    );
  };

  getPlayer = item => (
    <div className="w-full h-[69px] flex items-center justify-center ">
      <ToolTipIcon toolText="Preview Sign" href={`/player/?sign=${item.sign.id}`} target="_blank">
        <img
          className="w-[30px] h-[30px]"
          alt="preview"
          src="/assets/images/icons/play_no_bg.svg"
        />
      </ToolTipIcon>
    </div>
  );

  getCreator = item => (
    <ToolTipIcon
      toolText="Edit"
      onClick={() => launchCreator(item.sign.id, getParent(this.props, item.sign.parent).id)}
    >
      <i className="fa fa-paint-brush" />
    </ToolTipIcon>
  );

  getRemove = (item, index) => {
    const { onRemoveEntry } = this.props;

    return (
      <div
        data-test="sequence-entry-remove"
        className="w-full h-full flex items-center justify-center"
      >
        <ToolTipIcon toolText="Remove Sign" onClick={() => onRemoveEntry(index)}>
          <img
            src="/assets/images/icons/black_delete_icon.svg"
            alt="delete item"
            className="w-[30px] h-[30px]"
          />
        </ToolTipIcon>
      </div>
    );
  };

  render() {
    const { auth, data, onSort } = this.props;
    const entries = data ? data.filter(item => item.sign) : [];
    const p = getPermissions(auth);

    return (
      <SSTable
        className="responsive table-sequence"
        data={entries}
        headerHeight={50}
        rowHeight={50}
        rowsCount={entries.length - 1}
        onSort={onSort}
        selectable
        sortable={p.writer}
        zebra
      >
        <SSColumn containerClasses="!w-[25px]" cell={this.getPosition} />
        <SSColumn containerClasses="!w-[100px]" cell={this.getPreview} />
        <SSColumn header="Name" cell={this.getName} />
        <SSColumn containerClasses="!w-[105px]" header="Dimensions" cell={this.getDimensions} />
        <SSColumn containerClasses="!w-[105px]" header="Repeat" cell={this.getRepeat} />
        <SSColumn containerClasses="!w-[150px]" header="Playlist" cell={this.getPlaylist} />
        <SSColumn containerClasses="!w-[50px]" center header="Preview" cell={this.getPlayer} />
        {p.atLeastTierPro && p.writer && (
          <SSColumn containerClasses="!w-[50px]" header="Creator" cell={this.getCreator} />
        )}
        {p.writer && <SSColumn containerClasses="!w-[50px]" header="" cell={this.getRemove} />}
      </SSTable>
    );
  }
}

SequenceEntriesTable.propTypes = {
  auth: PropTypes.object.isRequired,
  folders: PropTypes.object.isRequired,
  data: PropTypes.array,
  onSort: PropTypes.func.isRequired,
  onChangeRepeat: PropTypes.func.isRequired,
  onClickPlaylist: PropTypes.func.isRequired,
  onRemovePlaylist: PropTypes.func.isRequired,
  onRemoveEntry: PropTypes.func.isRequired,
};
